import React, { useEffect, useState } from "react";
import GrayCard from "components/gray-card";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import TextInput from "components/inputs/text-input";
import { IVideoSongwriters, VideoDetailsKeys } from "types/videoData";

interface IProps {
  songWriters: IVideoSongwriters[];
  onChange: (key: VideoDetailsKeys, value: any) => void;
}
const SongWriters = ({ songWriters, onChange }: IProps) => {
  const OnChangeWriter = (index: number, value: string, key: string) => {
    const updatedWriters = [...(songWriters || [])];
    updatedWriters[index] = { ...updatedWriters[index], [key]: value };
    onChange("songWriters", updatedWriters);
  };

  const RemoveWriter = (index: number) => {
    const writes = [...(songWriters || [])];
    const updatedWriters = writes.filter((_, i) => index !== i);
    onChange("songWriters", updatedWriters);
  };

  const AddWriter = () => {
    const writes = [...(songWriters || [])];
    writes.push({ firstName: "", lastName: "" });

    onChange("songWriters", writes);
  };

  useEffect(() => {
    if (!songWriters?.length) {
      onChange("songWriters", [{ firstName: "", lastName: "" }]);
    }
  }, []);
  return (
    <GrayCard title="Songwriter(s)">
      {songWriters?.length && (
        <WriterItem>
          <TextInput
            label="First Name"
            placeholder="Enter Songwriter’s first name "
            value={songWriters[0].firstName}
            onChange={(e) => OnChangeWriter(0, e.target.value, "firstName")}
          />
          <TextInput
            label="Last Name"
            placeholder="Enter Songwriter’s last name "
            value={songWriters[0].lastName}
            onChange={(e) => OnChangeWriter(0, e.target.value, "lastName")}
          />
        </WriterItem>
      )}

      {songWriters?.map(({ firstName, lastName }, i) => {
        if (i === 0) {
          return null;
        }
        return (
          <WriterItem key={i}>
            <DeleteContainer onClick={() => RemoveWriter(i)}>
              <TrashIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  height="100%"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M11.9597 3.5H2.04297"
                    stroke="#FF3333"
                    stroke-width="0.875"
                    stroke-linecap="round"
                  />
                  <path
                    d="M10.9879 4.9585L10.7195 8.98297C10.6163 10.5317 10.5647 11.306 10.0601 11.7781C9.55549 12.2502 8.77942 12.2502 7.22729 12.2502H6.7762C5.22404 12.2502 4.44797 12.2502 3.94338 11.7781C3.4388 11.306 3.38717 10.5317 3.28392 8.98297L3.01562 4.9585"
                    stroke="#FF3333"
                    stroke-width="0.875"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5.54297 6.4165L5.83464 9.33317"
                    stroke="#FF3333"
                    stroke-width="0.875"
                    stroke-linecap="round"
                  />
                  <path
                    d="M8.45964 6.4165L8.16797 9.33317"
                    stroke="#FF3333"
                    stroke-width="0.875"
                    stroke-linecap="round"
                  />
                  <path
                    d="M3.79297 3.5C3.82557 3.5 3.84186 3.5 3.85664 3.49963C4.33698 3.48745 4.76073 3.18203 4.92418 2.73019C4.92921 2.71629 4.93436 2.70083 4.94467 2.6699L5.0013 2.5C5.04965 2.35496 5.07382 2.28244 5.10588 2.22087C5.23381 1.97521 5.47048 1.80462 5.74399 1.76095C5.81254 1.75 5.889 1.75 6.04189 1.75H7.96071C8.1136 1.75 8.19008 1.75 8.25862 1.76095C8.53214 1.80462 8.7688 1.97521 8.89673 2.22087C8.92881 2.28244 8.95296 2.35496 9.00132 2.5L9.05796 2.6699C9.06823 2.70079 9.07342 2.7163 9.07844 2.73019C9.24188 3.18203 9.66562 3.48745 10.146 3.49963C10.1608 3.5 10.177 3.5 10.2096 3.5"
                    stroke="#FF3333"
                    stroke-width="0.875"
                  />
                </svg>
              </TrashIcon>
              <Typography size="s" color={Colors.danger} ml="0.4">
                Remove Songwriter
              </Typography>
            </DeleteContainer>
            <TextInput
              label="First Name"
              placeholder="Enter Songwriter’s first name "
              value={firstName}
              onChange={(e) => OnChangeWriter(i, e.target.value, "firstName")}
            />
            <TextInput
              label="Last Name"
              placeholder="Enter Songwriter’s last name "
              value={lastName}
              onChange={(e) => OnChangeWriter(i, e.target.value, "lastName")}
            />
          </WriterItem>
        );
      })}

      <AddWriterContainer onClick={AddWriter}>
        <AddIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M7.0013 12.8332C10.223 12.8332 12.8346 10.2215 12.8346 6.99984C12.8346 3.77818 10.223 1.1665 7.0013 1.1665C3.77964 1.1665 1.16797 3.77818 1.16797 6.99984C1.16797 10.2215 3.77964 12.8332 7.0013 12.8332Z"
              stroke="#FEB73D"
              stroke-width="0.875"
            />
            <path
              d="M8.75 7H7M7 7H5.25M7 7V5.25M7 7V8.75"
              stroke="#FEB73D"
              stroke-width="0.875"
              stroke-linecap="round"
            />
          </svg>
        </AddIcon>
        <Typography color={Colors.yellow400} ml="0.8">
          Add Writer(s)
        </Typography>
      </AddWriterContainer>
    </GrayCard>
  );
};

export default SongWriters;

const AddWriterContainer = styled.div`
  margin-top: 2.4rem;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

const AddIcon = styled.div`
  width: 1.4rem;
  height: 1.4rem;
`;

const WriterItem = styled.div`
  margin-bottom: 2.4rem;
  display: grid;
  grid-template-columns: 48% 48%;
  justify-content: space-between;
  align-items: center;
  position: relative;
  @media only screen and (max-width: 769px) {
    grid-template-columns: 100%;
    grid-row-gap: 1rem;
  }
`;
const DeleteContainer = styled.div`
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  z-index: 2;
`;
const TrashIcon = styled.div`
  width: 1.4rem;
  height: 1.4rem;
`;
